import React from 'react';

import Grid from '@material-ui/core/Grid';
import { useLayoutStyles } from './Layout.styles';

export interface ILayoutProps {
    left?: Function;
    right?: Function;
}

export const Layout = ({ left, right }: ILayoutProps) => {
    const classes = useLayoutStyles();
    const LEFT_CONTAINER_WIDTH = 5;
    const RIGHT_CONTAINER_WIDTH = 7;

    return (
        <Grid container className={classes.container} data-signa="auth-layout-container">
            <Grid item lg={LEFT_CONTAINER_WIDTH} xs={LEFT_CONTAINER_WIDTH} data-signa="auth-layout-left">
                {left && left()}
            </Grid>
            <Grid item lg={RIGHT_CONTAINER_WIDTH} xs={RIGHT_CONTAINER_WIDTH} data-signa="auth-layout-right">
                {right && right()}
            </Grid>
        </Grid>
    );
};
